import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Notification } from '../models/notification.model';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly notifications = new BehaviorSubject<Notification[]>([]);

  getNotifications(): Observable<Notification[]> {
    return this.notifications.asObservable();
  }

  add(message: Notification): void {
    const current = this.notifications.getValue();
    this.notifications.next([
      ...current,
      {
        dismissable: true,
        timeout: 5000,
        severity: 'INFO',
        ...message,
      },
    ]);
  }

  remove(value: number | Notification): void {
    const current = this.notifications.getValue();

    const index =
      typeof value === 'number'
        ? value
        : current.findIndex((notification) => notification === value);

    if (index < 0 || index >= current.length) {
      return;
    }

    const updated = [...current];
    updated.splice(index, 1);
    this.notifications.next(updated);
  }

  clear(): void {
    this.notifications.next([]);
  }
}
